import { Text, VStack } from '@chakra-ui/react';

import { BellFilled } from '@/client/components/icons/ContinuIcons';
import { useTranslation } from 'react-i18next';

export default function NoNotificationsPlaceholder() {
  const { t } = useTranslation();

  return (
    <VStack
      spacing={1}
      backgroundColor="neutral.0"
      border="1px solid"
      borderColor="neutral.100"
      borderRadius="16px"
      paddingX={8}
      paddingY={6}
    >
      <BellFilled boxSize={6} color="neutral.400" />

      <Text fontSize="12px" fontWeight={400} color="neutral.600">
        {t('notifications.noNotifications')}
      </Text>
    </VStack>
  );
}
